<template>
  <div id="gerenciarCandidatos">
    <Header />

    <h3 class="titulo">Gestão de Candidatos</h3>

    <div id="Filtros" class="contorno">
      <div class="form-group buscaMaisRefresh col-lg-12">
        <div>
          <h4 class="card-title" :style="cssTitulo">Filtros</h4>
        </div>

        <div>
          <b-icon-plus
            v-b-toggle.collapse-1
            class="icone"
            @click="mostrarFiltros"
            v-if="this.filtrosVisiveis"
          ></b-icon-plus>
          <b-icon-dash
            v-b-toggle.collapse-1
            class="icone"
            @click="mostrarFiltros"
            v-if="!this.filtrosVisiveis"
          ></b-icon-dash>
        </div>
      </div>

      <b-collapse id="collapse-1" visible class="mt-2">
        <!-- Usado para copiar link para aréa de transferencia -->
        <!-- <input type="text" name="link" id="link" ref="copiar" v-model="link" style="display: none;"> -->

        <!-- <textarea class="textarea" ref="copiar">{{ meuTitulo }}</textarea> -->

        <!--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--FILTRO CANDIDATOS--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
        <div class="form-group buscaMaisRefresh col-lg-12">
          <!-- <label ref="copiar">{{ meuTitulo }}</label> -->
          <b-form-input
            type="text"
            class="form-control col-lg-3 mr-3"
            placeholder="Buscar por palavra chave..."
            v-model="search"
          ></b-form-input>

          <b-form-select
            v-if="empresaExibeAprovador"
            class="form-control col-lg-3 mr-3"
            v-model="filtroAprovador"
            :options="opcoesAprovador"
          ></b-form-select>

          <b-form-select
            v-if="dadosEmpresa && [70, 500].includes(Number(dadosEmpresa.id))"
            class="form-control col-lg-3 mr-3"
            :class="{ invisible: !empresaExibeFiltroDocumentosBaixados }"
            :disabled="!empresaExibeFiltroDocumentosBaixados"
            v-model="filtroDocumentosBaixados"
            :options="opcoesDocumentosBaixados"
          ></b-form-select>

          <b-button
            variant="none"
            class="form-control col-lg-2 button-atualizar"
            block
            @click="refresh"
            :style="cssVars"
            >Atualizar lista</b-button
          >
        </div>
      </b-collapse>
    </div>

    <div id="Candidatos" class="contorno">
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-danger"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3"
      >
        <b-tab
          :title="'Todos (' + resultTodos + ')'"
          @click="getCandidatosPorStatus('')"
          :active="abaAtiva === 'Todos'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>
        <b-tab
          :title="'Em Andamento (' + resultAndamento + ')'"
          @click="getCandidatosPorStatus('Em andamento')"
          :active="abaAtiva === 'Em andamento'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>
        <b-tab
          :title="'Em Validação (' + resultValidacao + ')'"
          @click="getCandidatosPorStatus('Em validação')"
          :active="abaAtiva === 'Em validação'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>
        <b-tab
          :title="'Em Aprovação (' + resultAprocacao + ')'"
          @click="getCandidatosPorStatus('Em aprovação')"
          :active="abaAtiva === 'Em aprovação'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>
        <b-tab
          :title="'Concluido (' + resultConcluido + ')'"
          @click="getCandidatosPorStatus('Concluídos')"
          :active="abaAtiva === 'Concluídos'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>
        <b-tab
          :title="'Rejeitado (' + resultRejeitado + ')'"
          @click="getCandidatosPorStatus('Rejeitados')"
          :active="abaAtiva === 'Rejeitados'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>
        <b-tab
          :title="'Alertas (' + resultAlertas + ')'"
          @click="getCandidatosPorStatus('Alertas')"
          :active="abaAtiva === 'Alertas'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>
        <b-tab
          v-if="empresaTemFollowUp"
          :title="'Pendências (' + resultPendencias + ')'"
          @click="getCandidatosPorStatus('Pendências')"
          :active="abaAtiva === 'Pendências'"
        >
          <!-- <p>I'm the first tab</p> -->
        </b-tab>

        <template v-slot:tabs-end>
          <!--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--LISTA DE CANDIDATOS--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

          <b-table
            class="altura"
            striped
            responsive
            hover
            small
            :fields="fieldsCondicionais"
            :items="itemsFilter"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template #cell(urlFotoPerfil)="data">
              <b-avatar
                class="avatar-foto-perfil"
                :src="data.item.urlFotoPerfil"
                size="4rem"
              ></b-avatar>
            </template>

            <template #cell(nome)="data">
              <tr>
                <td>
                  {{ data.item.nome }} <br />
                  {{ data.item.email }} <br />
                  <span class="info-celular">{{ data.item.celular }}</span>
                </td>
              </tr>
            </template>

            <template #cell(nomeFuncao)="data">
              <tr>
                <td>
                  {{ data.item.nomeFuncao }}
                  <template v-if="data.item.cliente">
                    <br />{{ data.item.cliente }}
                  </template>
                </td>
              </tr>
            </template>

            <template #cell(cidade)="data">
              <tr>
                <td>
                  {{ data.item.uf }} - {{ data.item.cidade }}
                  <template v-if="data.item.nomeRegiao">
                    <br />{{ data.item.nomeRegiao }}
                  </template>
                </td>
              </tr>
            </template>

            <template #cell(status)="data">
              <tr>
                <td>
                  <b-badge :variant="data.item.statusCor">
                    {{ data.item.statusDescricao }}</b-badge
                  >
                  <template v-if="mostrarAprovador(data.item)">
                    <div
                      class="aprovador"
                      :title="'Aprovado por ' + data.item.aprovadoPor"
                    >
                      {{ data.item.aprovadoPor }}
                      <span
                        v-if="data.item.tipoPagamentoGestao === 'CHEQUE'"
                        class="aprovador-cheque"
                        >Cheque</span
                      >
                    </div>
                  </template>
                </td>
              </tr>
            </template>

            <template #cell(progresso)="data">
              <div class="bar">
                <!-- {{  porcento="30" ? {'background' :color1} :  variant="info" }} -->
                <div
                  v-if="data.item.progresso <= 20"
                  class="progress2"
                  v-bind:style="{
                    background: data.item.color,
                    width: data.item.progresso + '%',
                  }"
                ></div>
                <div
                  v-else-if="
                    data.item.progresso > 21 && data.item.progresso <= 50
                  "
                  class="progress3"
                  v-bind:style="{
                    background: data.item.color,
                    width: data.item.progresso + '%',
                  }"
                ></div>
                <div
                  v-else
                  class="progress"
                  v-bind:style="{
                    background: data.item.color,
                    width: data.item.progresso + '%',
                  }"
                ></div>
                <span class="porcento">{{ data.item.progresso }}%</span>
              </div>
            </template>

            <template #cell(diasVencido)="data">
              <tr>
                <td>
                  <b-badge variant="danger" v-if="isPendente(data.item)">
                    {{ getDiasVencido(data.item) }} dias
                  </b-badge>
                </td>
              </tr>
            </template>

            <template v-slot:cell(actions)="data">
              <!-- <b-button-group> -->
              <b-dropdown
                variant="none"
                class="dropdown-acoes"
                @click="selecionar(data.item)"
                no-caret
                :style="cssVars"
                boundary
              >
                <template #button-content>
                  <span style="color: var(--font-color)">• • •</span>
                </template>

                <b-dropdown-item
                  v-for="permissao in permissoesUsuario"
                  :key="permissao.id"
                  @click="direcionarAcaoCandidato(data.item, permissao.id)"
                  >{{ permissao.permissao }}</b-dropdown-item
                >

                <b-dropdown-item v-if="permissoesUsuario.length == 0"
                  >Você não tem nenhuma permissão.</b-dropdown-item
                >

                <!-- <b-dropdown-item @click="abrirAvaliar(data.item)">Avaliar</b-dropdown-item>
                <b-dropdown-item @click="abrirConsulta(data.item)">Consultar</b-dropdown-item>
                <b-dropdown-item @click="modalHistorico(data.item)">Histórico</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="modalInatividade(data.item)">Cancelar por inatividade</b-dropdown-item>
                <b-dropdown-item @click="modalRemoverCandidato(data.item)">Excluir candidato</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showModalConfirm(data.item, 'Confirma o reenvio da prova?', 10)">Reenviar prova</b-dropdown-item>
                <b-dropdown-item @click="showModalConfirm(data.item, 'Confirma a liberação para captação de documentos?', 11)">Liberar para captação de documentos</b-dropdown-item>
                <b-dropdown-item @click="showModalConfirm(data.item, 'Confirma o reenvio de nova documentação para assinatura?', 12)">Reenviar documentação para assinatura</b-dropdown-item>
                <b-dropdown-item @click="modalHistoricoAssinaturas(data.item)">Histórico de assinaturas</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="enviarMensagem(data.item)">Enviar Mensagem por WhatsApp</b-dropdown-item>
                <b-dropdown-item @click="abrirModalCopiarLink(data.item)">Copiar link envio de documentação</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showModalMeioAssinatura(data.item)">Alterar meio de assinatura do contrato de adesão</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showModalEntrevista(data.item, 'avaliação')">Entrevista</b-dropdown-item>
                <b-dropdown-item @click="showModalEntrevista(data.item, 'consulta')">Consultar entrevista</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showModalAprovacaoContrato(data.item.id)">Aprovação de contrato manual</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showModalConfirm(data.item, 'Confirma o desbloqueio do candidato?', 18)">Desbloquear</b-dropdown-item> -->
              </b-dropdown>
              <!-- </b-button-group> -->
            </template>
          </b-table>
        </template>
      </b-tabs>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--MODAL HISTÓRICO--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL HISTÓRICO -->
      <div>
        <b-modal
          ref="modal-historico"
          hide-footer
          title="Histórico de Atualizações"
          modal-class="modal-historico-large"
        >
          <!-- <div class="d-block">
            <b-card no-body class="overflow-hidden" style="max-width: 540px;">
              <b-row no-gutters>
                <b-col md="2">
                  <b-avatar :src="candidato.urlFotoPerfil" size="4rem "></b-avatar>
                </b-col>
                <b-col md="10">
                  <b-card-body>
                    <h5>{{ candidato.nome }}</h5>
                    {{ candidato.email }}

                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div> -->

          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center">
              <b-avatar
                :src="candidato.urlFotoPerfil"
                size="4rem"
                class="mr-3"
              />

              <div class="d-flex flex-column">
                <h5>{{ candidato.nome }}</h5>
                <span>{{ candidato.email }}</span>
              </div>
            </div>

            <div class="d-flex align-items-end flex-column">
              <div class="d-flex align-items-center gap-2 mb-2">
                <div
                  v-if="
                    [70, 500].includes(candidato.idEmpresa) &&
                    [10, 22].includes(candidato.idStatus)
                  "
                  class="d-flex flex-column"
                  style="margin-right: 4.5rem"
                >
                  <b-form-checkbox
                    v-model="candidato.documentosBaixados"
                    @change="atualizarDocumentosBaixados"
                    class="mb-0"
                  >
                    Documentos baixados
                  </b-form-checkbox>
                  <template v-if="candidato.documentosBaixados && candidato.documentosBaixadosPor">
                    <small class="text-muted d-block">{{ candidato.documentosBaixadosPor }}</small>
                    <small class="text-muted d-block">{{ dataHoraDocumentosBaixados }}</small>
                  </template>
                </div>

                <b-button
                  variant="success"
                  class="px-3 mr-2"
                  @click="downloadDocumentosCandidato"
                  :disabled="downloadDocumentosLoading"
                  title="Baixar todos os documentos, contratos e histórico em ZIP"
                >
                  <b-spinner small v-if="downloadDocumentosLoading" class="" />
                  <b-icon-download v-else class="mr-2" />
                  {{ downloadDocumentosLoading ? "Preparando..." : "Download" }}
                </b-button>

                <b-button
                  variant="info"
                  class="px-2 ml-2"
                  v-if="
                    !alterarEmailForm.open &&
                    candidato.idStatus !== 9 &&
                    candidato.idStatus !== 10
                  "
                  @click="alterarEmailForm.open = !alterarEmailForm.open"
                  >Alterar e-mail</b-button
                >
              </div>

              <div class="d-flex" v-if="alterarEmailForm.open">
                <b-button
                  class="px-2"
                  variant="outline-info"
                  @click="alterarEmailForm.open = !alterarEmailForm.open"
                  >Voltar</b-button
                >

                <b-button
                  class="px-2 ml-2"
                  variant="info"
                  @click="atualizarEmailCandidato"
                  v-if="!alterarEmailForm.alterando"
                  >Confirmar</b-button
                >
                <b-button class="px-2 ml-2" variant="info" disabled v-else>
                  <b-spinner small />
                </b-button>
              </div>

              <b-collapse
                id="alterar-email-collapse"
                class="mt-3"
                :visible="alterarEmailForm.open"
              >
                <b-form>
                  <b-form-input
                    placeholder="Digite seu novo e-mail:"
                    v-model="alterarEmailForm.email"
                    type="email"
                  />

                  <b-form-input
                    placeholder="Confirme seu novo e-mail:"
                    class="mt-2"
                    v-model="alterarEmailForm.confirmaEmail"
                    type="email"
                  />
                </b-form>
              </b-collapse>
            </div>
          </div>

          <b-table
            striped
            responsive
            hover
            :fields="fields2"
            :items="historicos"
            outlined
          >
            <template v-slot:cell(actions)="data">
              <b-button
                variant="light"
                @click="abrirPdf(data.item)"
                title="PDF"
                v-if="data.item.linkForm"
              >
                <b-img
                  center
                  thumbnail
                  fluid
                  src="@/assets/pdf40.png"
                  alt="Image 1"
                ></b-img>
              </b-button>
            </template>

            <template v-slot:cell(statusEnvio)="data">
              <b-badge
                block
                variant="danger"
                v-if="data.item.erroEmail"
                :id="'popover-erro-envio-' + data.index"
                >Falha no envio</b-badge
              >
              <b-badge
                block
                variant="success"
                v-if="!data.item.erroEmail && data.item.dataEnvioEmail"
                >Enviado</b-badge
              >

              <!-- <b-popover :target="'popover-erro-envio-' + data.index" triggers="hover" placement="top">

                <template #title>Detalhes do erro</template>
                {{ data.item.erroEmail }}

              </b-popover> -->
            </template>

            <template v-slot:cell(reenviar)="data">
              <b-button
                block
                variant="info"
                v-if="data.item.reenviarEmail"
                :id="'btn-reenviar-email-' + data.index"
                @click="
                  reenviarEmail(
                    data.item.id,
                    `btn-reenviar-email-${data.index}`
                  )
                "
                >Reenviar</b-button
              >
            </template>

            <template v-slot:cell(statusReenvio)="data">
              <b-badge
                block
                variant="danger"
                v-if="data.item.erroReenvioEmail"
                :id="'popover-erro-envio-' + data.index"
                >Falha no envio</b-badge
              >
              <b-badge
                block
                variant="success"
                v-if="!data.item.erroReenvioEmail && data.item.dataReenvioEmail"
                >Enviado</b-badge
              >

              <!-- <b-popover :target="'popover-erro-envio-' + data.index" triggers="hover" placement="top">

                <template #title>Detalhes do erro</template>
                {{ data.item.erroReenvioEmail }}

              </b-popover> -->
            </template>

            <template v-slot:cell(justificativa)="data">
              <div
                style="
                  white-space: pre-line;
                  word-wrap: break-word;
                  max-width: 300px;
                "
                :id="'tooltip-historico-justificativa-' + data.index"
                v-if="
                  data.item.justificativa && data.item.justificativa !== '-'
                "
              >
                {{ data.item.justificativa }}
                <b-tooltip
                  :target="'tooltip-historico-justificativa-' + data.index"
                  placement="top"
                  boundary="viewport"
                  custom-class="tooltip-justificativa-largo"
                >
                  <div style="white-space: pre-line; text-align: left">
                    {{ data.item.justificativa }}
                  </div>
                </b-tooltip>
                <!-- Lógica de truncamento (descomente para voltar ao comportamento anterior):
                {{ data.item.justificativa && data.item.justificativa.length > 50 ?
                   data.item.justificativa.substring(0, 50) + '...' :
                   data.item.justificativa || '-' }}
                -->
              </div>
              <div
                v-else
                style="
                  white-space: pre-line;
                  word-wrap: break-word;
                  max-width: 300px;
                "
              >
                -
              </div>
            </template>
          </b-table>

          <!-- <div class="box-btn">
            <b-button class="btn-fechar text-center mt-2" variant="outline-danger" block @click="hideModalHistorico">fechar</b-button>
          </div> -->
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--MODAL INATIVIDADE--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL INATIVIDADES -->
      <div>
        <b-modal
          ref="modal-inat"
          hide-footer
          title="Deseja cancelar a inscrição do candidato?"
          size="sm"
        >
          <div class="d-block text-center">
            <tr class="feeds">
              <li>
                <div class="dados-candidato">
                  <b-avatar
                    :src="candidato.urlFotoPerfil"
                    size="5rem "
                  ></b-avatar
                  ><br />
                  <div>
                    {{ candidato.nome }}<br />
                    {{ candidato.email }}<br />
                    {{ candidato.nomeFuncao }}
                  </div>
                </div>
              </li>
            </tr>
          </div>

          <b-button
            class="mt-3"
            variant="outline-success"
            block
            @click="saveInatividade"
            >Sim</b-button
          >
          <b-button
            class="mt-2"
            variant="outline-danger"
            block
            @click="hideModalInat"
            >Não</b-button
          >
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--MODAL COPIAR LINK--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <!-- MODAL COPIAR LINK -->
      <div>
        <b-modal
          ref="modal-copiar-link"
          hide-footer
          title="Copiar link"
          size="lg"
        >
          <div class="col-lg-12">
            <div class="form-row">
              <div class="form-group col-lg-9">
                <b-form-input
                  id="link"
                  v-model="link"
                  readonly="readonly"
                  ref="copiar"
                ></b-form-input>
              </div>

              <div class="form-group col-lg-3">
                <div class="box-btn">
                  <b-button
                    class="btn-copiar-link text-center"
                    variant="info"
                    block
                    @click="copiarLink"
                    >Copiar</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--MODAL REMOVER REGISTRO --XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL REMOVER REGISTRO -->
      <div>
        <b-modal
          ref="modal-del-registro"
          hide-footer
          title="Deseja excluir o registro?"
          size="sm"
        >
          <b-button
            class="mt-3"
            variant="outline-success"
            block
            @click="delCandidato"
            >Sim</b-button
          >
          <b-button
            class="mt-2"
            variant="outline-danger"
            block
            @click="$refs['modal-del-registro'].hide()"
            >Não</b-button
          >
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--MODAL ASSINATURAS--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <!-- MODAL ASSINATURAS -->
      <div>
        <b-modal ref="modal-assinaturas" hide-footer title="Contrato" size="xl">
          <assinaturas :candidato="this.candidato"></assinaturas>
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX-- MODAL DE CONFIRMAÇÃO --XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL DE CONFIRMAÇÃO -->
      <div>
        <b-modal
          ref="modal-confirm"
          hide-footer
          :title="textoConfirme"
          size="lg"
        >
          <b-button
            class="mt-3"
            variant="outline-success"
            block
            @click="confirma"
            >Sim</b-button
          >
          <b-button
            class="mt-2"
            variant="outline-danger"
            block
            @click="$refs['modal-confirm'].hide()"
            >Não</b-button
          >
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX-- MODAL DE ALTERAÇÃO DE MEIO DE ASSINATURA DO CONTRATO DE ADESÃO --XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL DE ALTERAÇÃO DE MEIO DE ASSINATURA DO CONTRATO DE ADESÃO -->
      <div>
        <b-modal
          ref="modal-alteracao-meio-assinatura"
          hide-footer
          title="Alterar meio de assinatura do contrato de adesão"
        >
          <label
            >O meio de assinatura que selecionar vai sobrescrever o definido
            pela empresa:
          </label>
          <b-form-select
            :options="meiosAssinaturaContratoAdesao"
            v-model="meioAssinaturaCandidato"
          ></b-form-select>

          <br />
          <br />

          <b-button
            class="mt-3"
            variant="outline-success"
            block
            @click="alterarMeioAssinaturaCandidato"
            >Confirmar</b-button
          >
          <b-button
            class="mt-2"
            variant="outline-danger"
            block
            @click="hideModalMeioAssinatura"
            >Cancelar</b-button
          >
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX-- MODAL DE REGISTRO DE ENTREVISTA --XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL DE REGISTRO DE ENTREVISTA -->
      <div>
        <b-modal
          ref="modal-entrevista"
          size="lg"
          hide-footer
          :title="`Registro de Entrevista - ${candidato.nome}`"
        >
          <b-form-textarea
            v-if="interacaoModalEntrevista == 'avaliação'"
            rows="10"
            placeholder="Escreva aqui sobre como foi a entrevista:"
            v-model="candidato.novaEntrevista"
          />

          <b-form-textarea
            v-if="interacaoModalEntrevista == 'carregando'"
            rows="10"
            placeholder="Escreva aqui sobre como foi a entrevista:"
            v-model="candidato.novaEntrevista"
            readonly
          />

          <div v-if="interacaoModalEntrevista == 'consulta'">
            <b-form-textarea
              v-for="(entrevista, index) in candidato.entrevistas"
              :key="entrevista.id"
              v-model="entrevista.descricao"
              readonly
              :class="{ 'mb-4': index !== candidato.entrevistas.length - 1 }"
            />
          </div>

          <b-row class="mt-4" v-if="interacaoModalEntrevista == 'avaliação'">
            <div class="col-lg-4">
              <b-button variant="info" block @click="saveEntrevista('salvar')"
                >Salvar</b-button
              >
            </div>

            <div class="col-lg-4">
              <b-button
                variant="danger"
                block
                @click="saveEntrevista('reprovar')"
                >Reprovar</b-button
              >
            </div>

            <div class="col-lg-4">
              <b-button
                variant="success"
                block
                @click="saveEntrevista('aprovar')"
                >Aprovar</b-button
              >
            </div>
          </b-row>

          <h5
            v-if="interacaoModalEntrevista == 'carregando'"
            class="text-center mt-4"
          >
            Aguarde...
          </h5>
        </b-modal>
      </div>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX-- MODAL DE FOLLOW-UP --XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL DE FOLLOW-UP -->
      <ModalFollowUp
        ref="modal-follow-up"
        :candidato="candidato"
        :modoFollowUp="modoFollowUp"
        @follow-up-criado="refresh"
      />

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX-- MODAL DE APROVAÇÃO DE CONTRATO MANUAL --XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <!-- MODAL DE APROVAÇÃO DE CONTRATO MANUAL -->
      <div>
        <b-modal
          ref="modal-contrato-manual"
          hide-footer
          title="Aprovação de contrato manual"
        >
          <div v-if="aprovacaoContrato === 'manual'">
            <b-form-datepicker
              placeholder="Selecione a data de aprovação do contrato: "
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              :max="new Date().toISOString().split('T')[0]"
              :min="dataMinAprovacaoContrato"
              v-model="candidato.dataAprovacaoContrato"
            />

            <b-row class="mt-3">
              <div class="col-lg-6">
                <b-btn
                  variant="success"
                  block
                  @click="aprovarContratoManual(idCandidato)"
                  >Confirmar</b-btn
                >
              </div>

              <div class="col-lg-6">
                <b-btn
                  variant="danger"
                  block
                  @click="hideModalAprovacaoContrato"
                  >Cancelar</b-btn
                >
              </div>
            </b-row>
          </div>

          <div v-else-if="aprovacaoContrato === 'hibrido'">
            <span>Escolha a opção de aprovação do contrato:</span>

            <b-row class="mt-3">
              <div class="col-lg-6">
                <b-button
                  variant="success"
                  block
                  @click="aprovacaoContrato = 'manual'"
                  >Manual</b-button
                >
              </div>

              <div class="col-lg-6">
                <b-button
                  variant="info"
                  block
                  @click="aprovacaoContrato = 'sim'"
                  >Clicksign (eletrônica)</b-button
                >
              </div>
            </b-row>

            <b-button
              variant="danger"
              block
              @click="hideModalAprovacaoContrato"
              class="mt-3"
              >Cancelar</b-button
            >
          </div>

          <div v-else-if="aprovacaoContrato === 'sim'">
            <span>Tem certeza que deseja assinar o contrato digitalmente?</span>

            <b-row class="mt-3">
              <div class="col-lg-6">
                <b-button
                  variant="success"
                  block
                  @click="
                    reenviarDocumentacaoParaAssinaturas('modal-contrato-manual')
                  "
                  >Emitir contrato</b-button
                >
              </div>

              <div class="col-lg-6">
                <b-button
                  variant="danger"
                  block
                  @click="hideModalAprovacaoContrato"
                  >Cancelar</b-button
                >
              </div>
            </b-row>
          </div>
        </b-modal>
      </div>

      <!--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX--PÁGINAÇÃO--XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
      ></b-pagination>

      <b-row>
        <div v-if="this.exibindoConfiguracaoPaginacao == false">
          <b-icon-gear
            style="font-size: 20px; margin-left: 20px"
            @click="exibirConfigPaginacao"
          ></b-icon-gear>
        </div>

        <div v-if="this.exibindoConfiguracaoPaginacao == false">
          <span style="margin-left: 10px"
            >Alterar número de registros por página</span
          >
        </div>

        <div v-if="this.exibindoConfiguracaoPaginacao == true">
          <b-icon-gear-fill
            style="font-size: 20px; margin-left: 20px"
            @click="exibirConfigPaginacao"
          ></b-icon-gear-fill>
        </div>

        <div v-if="this.exibindoConfiguracaoPaginacao == true" class="col-lg-1">
          <b-form-select
            type="number"
            :options="optionsPaginacao"
            v-model="perPage"
          ></b-form-select>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import dayjs from "dayjs";
import validaCredencial from "../utils";
import Header from "@/components/Header";
import assinaturas from "./modal/assinaturas";
import ModalFollowUp from "@/components/candidatos/ModalFollowUp.vue";

export default {
  components: {
    Header,
    assinaturas,
    ModalFollowUp,
  },

  name: "ClienteList",
  el: ".box",
  data() {
    return {
      meuTitulo: "Histórico de Atulizações",
      link: "",

      form: {
        nome: "bolinha Lerolero",
        email: "lero@gmail.com",
      },

      idCandidato: null,

      dadosEmpresa: null,
      bgColor: "#a1a1a1",
      fontColor: "#FFFFFF",
      logo: "",
      pdf: "@/assets/pdf.png",

      search: "",
      filtroAprovador: null,
      filtroDocumentosBaixados: null,
      opcoesDocumentosBaixados: [
        { value: null, text: "Todos" },
        { value: true, text: "Documentos baixados" },
        { value: false, text: "Documentos não baixados" },
      ],
      resultTodos: "",
      resultAndamento: 0,
      resultValidacao: 0,
      resultAprocacao: 0,
      resultConcluido: 0,
      resultRejeitado: 0,
      resultAlertas: 0,
      resultPendencias: 0,
      empresaTemFollowUp: false,
      modoFollowUp: 0, // 0=Desativado, 1=Com prorrogação, 2=Somente leitura
      load: false,
      itemsTotal: [],
      items: [],
      // Declarado aqui para ser reativo e não ficar undefined antes do
      // primeiro carregamento (era atribuído direto em getCandidatos).
      itemsTodos: [],
      perPage: 5,
      currentPage: 1,
      abaAtiva: "Em validação",

      candidato: {
        nome: "",
        email: "",
        funcao: "",
        dataEmissaoContrato: "",
        dataAprovacaoContrato: "",
        entrevistas: [],
        novaEntrevista: "",
        idStatus: "",
        idEmpresa: null,
        documentosBaixados: false,
        documentosBaixadosEm: null,
        documentosBaixadosPor: null,
      },

      fields2: [
        { key: "status", label: "Status", sortable: true },
        { key: "dataAtualizacao", label: "Atualizado em" },
        { key: "actions", label: "Documentação" },
        { key: "dataEnvioEmail", label: "E-mail enviado em" },
        { key: "statusEnvio", label: "Status do envio" },
        { key: "reenviar", label: "Reenviar e-mail" },
        { key: "dataReenvioEmail", label: "E-mail reenviado em" },
        { key: "statusReenvio", label: "Status do reenvio" },
        {
          key: "justificativa",
          label: "Observações",
          thStyle: { minWidth: "200px", maxWidth: "300px" },
        },
      ],
      historicos: [],

      fields: [
        {
          key: "urlFotoPerfil",
          label: "Img",
        },
        { key: "nome", label: "Nome", sortable: true },
        { key: "cpf", label: "CPF", sortable: true },
        { key: "progresso", label: "Progresso", sortable: true },
        { key: "nomeFuncao", label: "Função", sortable: true },
        { key: "cidade", label: " UF - Cidade", sortable: true },
        {
          key: "status",
          label: "Status",
          sortable: true,
          sortByFormatted: true,
          formatter: (value, key, item) => item.statusDescricao,
        },
        // { key: "dataCreate", label: "Dt Inicio", sortable: true },
        // { key: "dataAtualizacao", label: "Dt Atualização", sortable: true },
        {
          key: "dataCreate",
          label: "Data Início",
          sortable: true,
          formatter: (value) => {
            return dayjs(value).format("DD/MM/YYYY");
          },
        },
        {
          key: "dataAtualizacao",
          label: "Dt Atualização",
          sortable: true,
          formatter: (value) => {
            return dayjs(value).format("DD/MM/YYYY");
          },
        },
        { key: "actions", label: "Ações" },
      ],

      fieldsPendencias: [
        {
          key: "urlFotoPerfil",
          label: "Img",
        },
        { key: "nome", label: "Nome", sortable: true },
        { key: "cpf", label: "CPF", sortable: true },
        { key: "nomeFuncao", label: "Função", sortable: true },
        {
          key: "responsavelTipo",
          label: "Responsável",
          sortable: true,
          formatter: (value) => {
            if (value === "cooperado") return "Cooperado";
            if (value === "cooperativa") return "Cooperativa";
            if (value === "cooperado.") return "Cooperado.";
            return value || "-";
          },
        },
        {
          key: "data_base",
          label: "Prazo",
          sortable: true,
          formatter: (value) => {
            return value ? dayjs(value).format("DD/MM/YYYY") : "-";
          },
        },
        { key: "diasVencido", label: "Dias Vencido", sortable: true },
        {
          key: "status",
          label: "Status",
          sortable: true,
          sortByFormatted: true,
          formatter: (value, key, item) => item.statusDescricao,
        },
        { key: "actions", label: "Ações" },
      ],

      filtrosVisiveis: false,
      mensagemWhatsapp: "",

      exibindoConfiguracaoPaginacao: false,
      optionsPaginacao: [5, 10, 15, 20],

      textoConfirme: "",

      meiosAssinaturaContratoAdesao: [],
      meioAssinaturaCandidato: null,

      interacaoModalEntrevista: "",

      aprovacaoContrato: null,

      permissoesUsuario: [],

      downloadDocumentosLoading: false,

      alterarEmailForm: {
        open: false,
        email: "",
        confirmaEmail: "",
        alterando: false,
      },
    };
  },

  async created() {
    this.dadosEmpresa = this.$store.state.empresaSelecionada;

    if (this.dadosEmpresa) {
      this.bgColor = this.dadosEmpresa.cor;
      this.logo = this.dadosEmpresa.logoPath;
      this.color = this.dadosEmpresa.titulo;
      this.fontColor = this.dadosEmpresa.corFonte;

      this.aprovacaoContrato = this.dadosEmpresa.assinarClicksign;

      this.getPermissoesUsuario(
        this.$store.state.auth.user.idUser,
        this.dadosEmpresa.id
      );

      this.verificarFollowUpEmpresa();
      this.verificarModoFollowUp();

      this.refresh();
    } else {
      window.location = "/login";
    }
  },

  methods: {
    todos(data) {
      console.log("OK", data);
    },

    msg(titulo, texto, cor, time = 10000) {
      this.toastCount++;
      this.$bvToast.toast(texto, {
        title: titulo,
        variant: cor,
        solid: true,
        autoHideDelay: time,
        appendToast: true,
      });
    },

    async getCandidatos(abaParaRestaurar = "Em validação") {
      this.items = [];
      this.load = true;

      try {
        const res = await api.get(
          "web-cliente/candidatos/" + this.dadosEmpresa.id
        );

        this.itemsTodos = res.data;
        this.items = res.data;
        this.load = false;

        this.resultTodos = this.items.length;
        this.resultAndamento = this.items.filter(
          (item) => item.status == "Em andamento"
        ).length;
        this.resultValidacao = this.items.filter(
          (item) => item.status == "Em validação"
        ).length;
        this.resultAprocacao = this.items.filter(
          (item) => item.status == "Em aprovação"
        ).length;
        this.resultConcluido = this.items.filter(
          (item) => item.status == "Concluídos"
        ).length;
        this.resultRejeitado = this.items.filter(
          (item) => item.status == "Rejeitados"
        ).length;
        this.resultAlertas = this.items.filter(
          (item) => item.status == "Alertas"
        ).length;

        this.resultPendencias = this.items.filter((item) =>
          this.isPendente(item)
        ).length;

        this.getCandidatosPorStatus(
          abaParaRestaurar === "Todos" ? "" : abaParaRestaurar,
          true
        );
      } catch (error) {
        this.load = false;
        this.msg("ERRO AO BUSCAR CLIENTES", error.response.data, "danger");
      }
    },

    // manterFiltros: true quando é uma restauração interna (refresh),
    // false quando é o usuário trocando de aba manualmente.
    getCandidatosPorStatus(status, manterFiltros = false) {
      this.abaAtiva = status || "Todos";

      if (!manterFiltros) {
        // O aprovador e o filtro de documentos baixados só existem em
        // algumas abas; manter ao trocar esvaziaria a lista sem indicação
        // visual.
        this.filtroAprovador = null;
        this.filtroDocumentosBaixados = null;
      }

      if (status === "Pendências") {
        this.items = this.itemsTodos.filter((item) => this.isPendente(item));
      } else {
        this.items = status
          ? this.itemsTodos.filter((item) => item.status == status)
          : this.itemsTodos;
      }
    },

    isPendente(candidato) {
      if (!candidato.data_base) return false;

      const hoje = dayjs();
      const dataBase = dayjs(candidato.data_base);

      return dataBase.isBefore(hoje, "day");
    },

    getDiasVencido(candidato) {
      if (!candidato.data_base) return 0;

      const hoje = dayjs();
      const dataBase = dayjs(candidato.data_base);

      if (dataBase.isBefore(hoje, "day")) {
        return hoje.diff(dataBase, "days");
      }
      return 0;
    },

    async refresh() {
      const abaAtual = this.abaAtiva;
      await this.getCandidatos(abaAtual);
    },

    async abrirConsulta(candidato) {
      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(2);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          5000
        );
        return;
      }
      //------------------------------------------------------------------

      localStorage.setItem("idSolicitacao", candidato.id);
      this.$router.push("/candidato/consultar");
    },

    async abrirAvaliar(candidato) {
      // console.log('candidato.id', candidato.id)

      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(1);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          5000
        );
        return;
      }
      //------------------------------------------------------------------

      if (candidato.idStatus != 6 && candidato.idStatus != 7) {
        this.msg(
          "CANDIDATO NÃO PODE SER AVALIADO",
          "Aguarde...",
          "warning",
          3000
        );
        return;
      }

      // Atualiza status 6 para 7.
      if (candidato.idStatus == 6) {
        api.put("web-cliente/candidato/atualiza-status", {
          idSolicitacao: candidato.id,
        });
      }

      localStorage.setItem("idSolicitacao", candidato.id);
      this.$router.push("/candidato/avaliar");
    },

    async modalHistorico(candidato) {
      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(3);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          4000
        );
        return;
      }
      //------------------------------------------------------------------

      await this.getHistoricos(candidato.id);

      this.candidato.id = candidato.id;
      this.candidato.idEmpresa = candidato.idEmpresa;
      this.candidato.nome = candidato.nome;
      this.candidato.cpf = candidato.cpf;
      this.candidato.email = candidato.email;
      this.candidato.urlFotoPerfil = candidato.urlFotoPerfil;
      this.candidato.idStatus = candidato.idStatus;
      this.candidato.documentosBaixados = !!candidato.documentosBaixados;
      this.candidato.documentosBaixadosEm = candidato.documentosBaixadosEm;
      this.candidato.documentosBaixadosPor = candidato.documentosBaixadosPor;
      this.alterarEmailForm.email = "";
      this.alterarEmailForm.confirmaEmail = "";
      this.alterarEmailForm.open = false;
      this.$refs["modal-historico"].show();
    },

    hideModalHistorico() {
      this.$refs["modal-historico"].hide();
    },

    async atualizarDocumentosBaixados(valor) {
      let confirmado = false;
      try {
        confirmado = await this.$bvModal.msgBoxConfirm(
          valor
            ? "Confirma que os documentos desta solicitação já foram baixados?"
            : "Confirma que os documentos desta solicitação ainda não foram baixados?",
          {
            title: "Confirmar",
            okVariant: "success",
            okTitle: "Confirmar",
            cancelTitle: "Cancelar",
            centered: true,
            hideHeaderClose: false,
          }
        );
      } catch (error) {
        // Fechado via X, backdrop ou Esc: msgBoxConfirm pode rejeitar a
        // promise em vez de resolver false/null. Trata como cancelado.
        confirmado = false;
      }

      if (!confirmado) {
        this.candidato.documentosBaixados = !valor;
        return;
      }

      try {
        await api.put("web-cliente/candidato/documentos-baixados", {
          idSolicitacao: this.candidato.id,
          documentosBaixados: valor,
        });

        this.candidato.documentosBaixadosEm = valor ? new Date() : null;
        this.candidato.documentosBaixadosPor = valor
          ? this.$store.state.auth.user.nome
          : null;

        // Sincroniza a linha da tabela por trás do modal, sem precisar
        // de um refresh completo, pra ela sair do filtro/aba correta.
        const item = this.itemsTodos.find((i) => i.id === this.candidato.id);
        if (item) {
          item.documentosBaixados = this.candidato.documentosBaixados;
          item.documentosBaixadosEm = this.candidato.documentosBaixadosEm;
          item.documentosBaixadosPor = this.candidato.documentosBaixadosPor;
        }
      } catch (error) {
        this.candidato.documentosBaixados = !valor;
        this.msg(
          "Erro",
          "Não foi possível atualizar o indicador de download.",
          "danger",
          4000
        );
      }
    },

    async getHistoricos(idCandidato) {
      try {
        const res = await api.get(
          `web-cliente/candidato/historico/${idCandidato}`
        );

        this.historicos = res.data;
      } catch (error) {
        this.msg("ERRO AO BUSCAR HISTÓRICOS", error.response.data, "danger");
      }
    },

    abrirPdf(historico) {
      window.open(historico.linkForm, "_blank");
    },

    async abrirModalCopiarLink(candidato) {
      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(30);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          3000
        );
        return;
      }
      //------------------------------------------------------------------

      if (!candidato.linkEnvioDocs) {
        this.msg(
          "CANDIDATO NÃO POSSUI O LINK DE ENVIO",
          "...",
          "warning",
          3000
        );
        return;
      }

      this.link = candidato.linkEnvioDocs.split(" ").join("%20");
      this.$refs["modal-copiar-link"].show();
    },

    copiarLink() {
      // var copyTextarea = document.getElementById("link")
      var copyTextarea = this.$refs.copiar;

      copyTextarea.select();
      document.execCommand("copy");
    },

    async modalInatividade(candidato) {
      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(4);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          5000
        );
        return;
      }
      //------------------------------------------------------------------

      if (candidato.idStatus == 10) {
        this.msg("CANDIDATO NÃO PODE SER CANCELADO", "...", "warning", 3000);
        return;
      }

      this.candidato.id = candidato.id;
      this.candidato.nome = candidato.nome;
      this.candidato.email = candidato.email;
      this.candidato.nomeFuncao = candidato.nomeFuncao;
      this.candidato.urlFotoPerfil = candidato.urlFotoPerfil;
      this.$refs["modal-inat"].show();
    },

    hideModalInat() {
      this.$refs["modal-inat"].hide();
    },

    async modalRemoverCandidato(candidato) {
      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(5);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          3000
        );
        return;
      }
      //------------------------------------------------------------------

      this.idCandidato = candidato.id;
      this.$refs["modal-del-registro"].show();
    },

    async saveInatividade() {
      try {
        await api.put("web-cliente/candidatos/cancelar", {
          idSolicitacao: this.candidato.id,
        });

        this.$refs["modal-inat"].hide();
        this.msg("Candidato", "cancelado com sucesso.", "success");
        this.refresh();
      } catch (error) {
        this.load = false;
        this.msg("ERRO AO CANCELAR CLIENTES", error.response.data, "danger");
      }
    },

    async delCandidato() {
      try {
        const user = this.$store.state.auth.user;

        this.$refs["modal-del-registro"].hide();
        await api.delete(
          `web-cliente/candidato/${this.idCandidato}/${user.nome}`
        );

        this.msg("Candidato", "Removido com sucesso.", "success");
        this.refresh();
      } catch (error) {
        this.load = false;
        this.msg("ERRO AO REMOVER CANDIDATO", error.response.data, "danger");
      }
    },

    mostrarFiltros() {
      if (this.filtrosVisiveis) this.filtrosVisiveis = false;
      else this.filtrosVisiveis = true;
    },

    async enviarMensagem(candidato) {
      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(20);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          3000
        );
        return;
      }
      //------------------------------------------------------------------

      let numeroSemMascara = candidato.celular.split("-").join("");
      numeroSemMascara = numeroSemMascara.split("(").join("");
      numeroSemMascara = numeroSemMascara.split(")").join("");
      numeroSemMascara = numeroSemMascara.split(" ").join("");

      try {
        const res = await api.get(
          `web-cliente/candidato/mensagem/` + candidato.idEmpresa
        );

        const nomeEmpresa = res.data;

        this.mensagemWhatsapp = `Olá sr(a) ${candidato.nome}, somos do departamento de adesão da ${nomeEmpresa}`;
        this.mensagemWhatsapp = this.mensagemWhatsapp.split(" ").join("%20");

        window.open(
          `https://wa.me/55${numeroSemMascara}?text=${this.mensagemWhatsapp}`
        );
      } catch (error) {
        this.msg("ERRO AO BUSCAR MENSAGEM", error.response.data, "danger");
      }
    },

    exibirConfigPaginacao() {
      if (this.exibindoConfiguracaoPaginacao == true)
        this.exibindoConfiguracaoPaginacao = false;
      else this.exibindoConfiguracaoPaginacao = true;
    },

    async showModalConfirm(candidato, texto) {
      // const acessoPermitido = await validaCredencial(codCredencial)

      // if (acessoPermitido == 'fail') {

      //   this.msg("ATENÇÃO", "Você não possui permissão para continuar.", "warning", 3000);
      //   return

      // }

      this.idCandidato = candidato.id;
      this.textoConfirme = texto;
      this.$refs["modal-confirm"].show();
    },

    confirma() {
      if (this.textoConfirme == "Confirma o reenvio da prova?")
        this.reenviarProva();
      else if (
        this.textoConfirme ==
        "Confirma a liberação para captação de documentos?"
      )
        this.liberarParaCaptacaoDocumentos();
      else if (
        this.textoConfirme ==
        "Confirma o reenvio de nova documentação para assinatura?"
      )
        this.reenviarDocumentacaoParaAssinaturas("modal-confirm");
      else if (this.textoConfirme == "Confirma o desbloqueio do candidato?")
        this.desbloquearCandidato();
      else if (this.textoConfirme == "Confirma a geração do contrato manual?")
        this.gerarContratoManual();
      else if (
        this.textoConfirme == "Confirma o cancelamento do contrato digital?"
      )
        this.cancelarContratoDigital();
      else if (
        this.textoConfirme ==
        "Confirma o retorno do cadastro para ajustes? (ADM)"
      )
        this.liberarRetornoCadastroAjustes();
    },

    async reenviarProva() {
      // console.log("candidato", candidato);

      this.$refs["modal-confirm"].hide();

      try {
        await api.post("web-cliente/candidato/reenvia-prova", {
          idSolicitacao: this.idCandidato,
        });

        this.msg("O CANDIDATO", "RECEBEU UM NOVO LINK PARA PROVA.", "success");
        this.refresh();
      } catch (error) {
        if (error.response.status == 402)
          this.msg("ATENÇÃO", error.response.data, "warning");
        else this.msg("ATENÇÃO", "Erro ao reenviar a prova", "danger");
      }
    },

    async liberarParaCaptacaoDocumentos() {
      this.$refs["modal-confirm"].hide();
      this.msg("AGUARDE", "Liberando a captação...", "info", 2000);

      try {
        await api.post("web-cliente/candidato/liberar-captacao-documentos", {
          idSolicitacao: this.idCandidato,
        });

        this.msg(
          "O CANDIDATO",
          "FOI LIBERADO PARA CAPTAÇÃO DE DOCUMENTOS",
          "success"
        );
        this.refresh();
      } catch (error) {
        if (error.response.status == 402)
          this.msg("ATENÇÃO", error.response.data, "warning");
        else this.msg("ATENÇÃO", "Erro ao liberar captação.", "danger");
      }
    },

    async liberarRetornoCadastroAjustes() {
      this.$refs["modal-confirm"].hide();
      this.msg("AGUARDE", "Liberando a captação...", "info", 2000);

      try {
        //criar a rota nova na api
        await api.post(
          "web-cliente/candidato/liberar-retorno-cadastro-ajustes",
          {
            idSolicitacao: this.idCandidato,
          }
        );

        this.msg("A SOLICITAÇÃO", "FOI LIBERADA PARA AJUSTE", "success");
        this.refresh();
      } catch (error) {
        if (error.response.status == 402)
          this.msg("ATENÇÃO", error.response.data, "warning");
        else this.msg("ATENÇÃO", "Erro ao liberar captação.", "danger");
      }
    },

    async reenviarDocumentacaoParaAssinaturas(modalRef) {
      this.$refs[modalRef].hide();

      try {
        await api.post(
          "web-cliente/candidato/reenviar-documentacao-assinaturas",
          {
            idSolicitacao: this.idCandidato,
          }
        );

        this.msg(
          "O CANDIDATO",
          "REENVIADO NOVOS DOCUMENTOS PARA ASSINATURAS.",
          "success"
        );
        this.refresh();
      } catch (error) {
        if (error.response.status == 402)
          this.msg("ATENÇÃO", error.response.data, "warning");
        else
          this.msg("ATENÇÃO", "Erro ao reenviar novos documentos.", "danger");
      }
    },

    async modalHistoricoAssinaturas(candidato) {
      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(3);
      if (acessoPermitido == "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para continuar.",
          "warning",
          4000
        );
        return;
      }
      //------------------------------------------------------------------

      this.candidato.id = candidato.id;
      this.candidato.nome = candidato.nome;
      this.candidato.email = candidato.email;
      this.candidato.urlFotoPerfil = candidato.urlFotoPerfil;
      this.$refs["modal-assinaturas"].show();
    },

    getMeiosAssinaturaContratoAdesao() {
      api
        .get("web-cliente/candidato/meios-assinatura")
        .then((res) => {
          this.meiosAssinaturaContratoAdesao = res.data;
        })
        .catch((err) => this.msg("ERRO", err.response.data, "danger"));
    },

    showModalMeioAssinatura(candidato) {
      this.idCandidato = candidato.id;
      this.$refs["modal-alteracao-meio-assinatura"].show();
      this.getMeiosAssinaturaContratoAdesao();
      this.meioAssinaturaCandidato = candidato.meioAssinatura;
    },

    hideModalMeioAssinatura() {
      this.idCandidato = null;
      this.$refs["modal-alteracao-meio-assinatura"].hide();
    },

    async alterarMeioAssinaturaCandidato() {
      await api.put("web-cliente/candidato/meio-assinatura", {
        idSolicitacao: this.idCandidato,
        meioAssinatura: this.meioAssinaturaCandidato,
      });

      this.msg(
        "O MEIO DE ASSINATURA DO CONTRATO DE ADESÃO",
        "FOI ATUALIZADO COM SUCESSO.",
        "success",
        2000
      );
      this.hideModalMeioAssinatura();
      this.getCandidatos();
    },

    async showModalEntrevista(candidato, interacao) {
      await api
        .get(
          `web-cliente/candidato/verificar-entrevista/${candidato.id}/${interacao}`
        )
        .then((res) => {
          this.idCandidato = candidato.id;

          if (interacao == "consulta") this.candidato.entrevistas = res.data;
          else if (interacao == "avaliação") {
            if (res.data.possuiEntrevista == true)
              this.candidato.novaEntrevista = res.data.entrevistaSalva;
          }

          this.candidato.nome = candidato.nome;
          this.interacaoModalEntrevista = interacao;
          this.$refs["modal-entrevista"].show();
        })
        .catch((err) => this.msg("ATENÇÃO", err.response.data, "danger", 2000));
    },

    async saveEntrevista(acao) {
      this.interacaoModalEntrevista = "carregando";

      const body = {
        idSolicitacao: this.idCandidato,
        descricao: this.candidato.novaEntrevista,
        acao: acao,
      };

      await api
        .post("web-cliente/candidato/entrevista", body)
        .then(() => {
          if (acao == "salvar")
            this.msg("ENTREVISTA", "SALVA COM SUCESSO.", "success", 2000);
          else this.msg("ENTREVISTA", "AVALIADA COM SUCESSO.", "success", 2000);
          this.$refs["modal-entrevista"].hide();
          this.candidato.novaEntrevista = "";
          this.refresh();
        })
        .catch((err) => this.msg("ERRO", err.response.data, "danger"));
    },

    async getPermissoesUsuario(idUsuario, idEmpresa) {
      await api
        .get(
          `web-cliente/candidato/usuario-permissoes/${idUsuario}/${idEmpresa}`
        )
        .then((res) => {
          this.permissoesUsuario = res.data;
        })
        .catch((err) => this.msg("ERRO", err.response.data, "danger"));
    },

    async showModalAprovacaoContrato(candidato) {
      await api
        .get(
          `web-cliente/candidato/verificar-aprovacao-contrato/${candidato.id}`
        )
        .then((res) => {
          this.idCandidato = candidato.id;
          this.candidato.dataEmissaoContrato =
            candidato.dataEmissaoContratoManual;
          this.aprovacaoContrato = res.data;
          this.candidato.dataAprovacaoContrato = "";
          this.$refs["modal-contrato-manual"].show();
        })
        .catch((err) => this.msg("ATENÇÃO", err.response.data, "danger", 2000));
    },

    hideModalAprovacaoContrato() {
      this.idCandidato = "";
      this.aprovacaoContrato = "";
      this.dataAprovacaoContrato = "";
      this.candidato.dataAprovacaoContrato = "";
      this.$refs["modal-contrato-manual"].hide();
    },

    async aprovarContratoManual(idCandidato) {
      const body = {
        idSolicitacao: idCandidato,
        dataAprovacaoContrato: this.candidato.dataAprovacaoContrato,
      };

      await api
        .put("web-cliente/candidato/aprovacao-contrato", body)
        .then(() => {
          this.hideModalAprovacaoContrato();
          this.msg("SUCESSO", "CONTRATO MANUAL APROVADO", "success", 2000);
          this.refresh();
        })
        .catch((err) => this.msg("ATENÇÃO", err.response.data, "danger", 2000));
    },

    async desbloquearCandidato() {
      await api
        .put("web-cliente/candidato/desbloqueio", {
          idSolicitacao: this.idCandidato,
        })
        .then((res) => {
          this.msg("SUCESSO", res.data, "success", 2000);
          this.$refs["modal-confirm"].hide();
          this.refresh();
        })
        .catch((err) => this.msg("ATENÇÃO", err.response.data, "danger", 2000));
    },

    direcionarAcaoCandidato(candidato, idPermissao) {
      if (idPermissao == 1) this.abrirAvaliar(candidato);
      else if (idPermissao == 2) this.abrirConsulta(candidato);
      else if (idPermissao == 3) this.modalHistorico(candidato);
      else if (idPermissao == 4) this.modalInatividade(candidato);
      else if (idPermissao == 5) this.modalRemoverCandidato(candidato);
      else if (idPermissao == 120)
        this.showModalConfirm(
          candidato,
          "Confirma o retorno do cadastro para ajustes? (ADM)"
        );
      else if (idPermissao == 10)
        this.showModalConfirm(candidato, "Confirma o reenvio da prova?");
      else if (idPermissao == 11)
        this.showModalConfirm(
          candidato,
          "Confirma a liberação para captação de documentos?"
        );
      else if (idPermissao == 12)
        this.showModalConfirm(
          candidato,
          "Confirma o reenvio de nova documentação para assinatura?"
        );
      else if (idPermissao == 20) this.enviarMensagem(candidato);
      else if (idPermissao == 30) this.abrirModalCopiarLink(candidato);
      else if (idPermissao == 101) this.showModalMeioAssinatura(candidato);
      else if (idPermissao == 102) this.modalHistoricoAssinaturas(candidato);
      else if (idPermissao == 103)
        this.showModalEntrevista(candidato, "avaliação");
      else if (idPermissao == 104)
        this.showModalEntrevista(candidato, "consulta");
      else if (idPermissao == 104)
        this.showModalEntrevista(candidato, "consulta");
      else if (idPermissao == 105) this.showModalAprovacaoContrato(candidato);
      else if (idPermissao == 106)
        this.showModalConfirm(
          candidato,
          "Confirma o desbloqueio do candidato?"
        );
      else if (idPermissao == 107)
        this.showModalConfirm(
          candidato,
          "Confirma a geração do contrato manual?"
        );
      else if (idPermissao == 108)
        this.showModalConfirm(
          candidato,
          "Confirma o cancelamento do contrato digital?"
        );
      else if (idPermissao == 130) this.showModalFollowUp(candidato);
    },

    async gerarContratoManual() {
      this.$refs["modal-confirm"].hide();

      await api
        .post(`web-cliente/candidato/contrato-manual/${this.idCandidato}`)
        .then(() => {
          this.msg("SUCESSO", "CONTRATO MANUAL GERADO.", "success", 2000);
          this.refresh();
        })
        .catch((err) => this.msg("ATENÇÃO", err.response.data, "danger", 2000));
    },

    async reenviarEmail(idRegistroHistorico, idButton) {
      const button = document.getElementById(idButton);
      button.disabled = true;
      button.innerText = "Enviando...";

      await api
        .put(
          `web-cliente/candidato/reenviar-email-historico/${idRegistroHistorico}`
        )
        .then(async () => {
          await this.getHistoricos(this.candidato.id);

          button.disabled = false;
          button.innerText = "Reenviar";
        })
        .catch((err) => this.msg("ATENÇÃO", err.response.data, "danger", 2000));
    },

    async cancelarContratoDigital() {
      await api
        .post("web-cliente/candidato/cancelar-contrato-digital", {
          idSolicitacao: this.idCandidato,
        })
        .then(() => {
          this.msg("SUCESSO", "CONTRATO DIGITAL CANCELADO", "success", 2000);
          this.$refs["modal-confirm"].hide();
          this.refresh();
        })
        .catch((err) => this.msg("ATENÇÃO", err.response.data, "danger", 2000));
    },

    async atualizarEmailCandidato() {
      this.alterarEmailForm.alterando = true;

      await api
        .put("web-cliente/candidato/atualizar-email", {
          email: this.alterarEmailForm.email,
          confirmaEmail: this.alterarEmailForm.confirmaEmail,
          idSolicitacao: this.candidato.id,
        })
        .then(async () => {
          this.alterarEmailForm.alterando = false;
          this.alterarEmailForm.open = false;
          this.msg(
            "SUCESSO",
            "E-MAIL ATUALIZADO COM SUCESSO.",
            "success",
            2000
          );
          this.$refs["modal-historico"].hide();
          this.refresh();
        })
        .catch((err) => {
          this.alterarEmailForm.alterando = false;
          this.msg("ERRO", err.response.data, "danger", 2000);
        });
    },

    async downloadDocumentosCandidato() {
      this.downloadDocumentosLoading = true;

      try {
        // Fazer requisição para download do ZIP
        const response = await api.get(
          `web-cliente/candidato/download-documentos/${this.candidato.id}`,
          {
            responseType: "blob", // Importante: receber como blob
            timeout: 300000, // 5 minutos (arquivo pode ser grande)
          }
        );

        // Extrair nome do arquivo do header Content-Disposition
        const contentDisposition = response.headers["content-disposition"];
        console.log("🔍 Header Content-Disposition:", contentDisposition);

        const cpfLimpo = this.candidato.cpf
          ? this.candidato.cpf.replace(/[^0-9]/g, "")
          : "sem-cpf";
        const nomeLimpo = this.candidato.nome
          ? this.candidato.nome.replace(/\s+/g, "-")
          : "documento";
        let nomeArquivo = `${nomeLimpo}_${cpfLimpo}.zip`;

        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (match && match[1]) {
            nomeArquivo = match[1].replace(/['"]/g, ""); // Remove aspas
            console.log("✅ Nome extraído do header:", nomeArquivo);
          }
        } else {
          console.log(
            "⚠️ Header Content-Disposition não encontrado, usando fallback"
          );
        }

        // Criar URL do blob e iniciar download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nomeArquivo);
        document.body.appendChild(link);
        link.click();

        // Limpar
        link.remove();
        window.URL.revokeObjectURL(url);

        this.msg(
          "DOWNLOAD CONCLUÍDO",
          "Todos os documentos foram baixados com sucesso!",
          "success",
          3000
        );
      } catch (error) {
        console.error("Erro ao baixar documentos:", error);

        let mensagemErro = "Erro ao baixar documentos. Tente novamente.";

        if (error.response && error.response.data) {
          // Se o erro vier como blob, converter para texto
          if (error.response.data instanceof Blob) {
            try {
              const text = await error.response.data.text();
              const errorData = JSON.parse(text);
              mensagemErro =
                errorData.message || errorData.error || mensagemErro;
            } catch (parseError) {
              // Se não conseguir parsear, usar mensagem padrão
              console.warn(
                "Falha ao parsear resposta de erro do blob:",
                parseError
              );
            }
          } else {
            mensagemErro =
              error.response.data.message ||
              error.response.data.error ||
              mensagemErro;
          }
        }

        this.msg("ERRO NO DOWNLOAD", mensagemErro, "danger", 4000);
      } finally {
        this.downloadDocumentosLoading = false;
      }
    },

    async verificarFollowUpEmpresa() {
      try {
        const followUpAtivo = await this.$store.dispatch(
          "fetchEmpresaFollowUp",
          this.dadosEmpresa.id
        );
        this.empresaTemFollowUp = followUpAtivo;
      } catch (error) {
        console.error(
          "Erro ao verificar status do follow-up da empresa:",
          error
        );
        this.empresaTemFollowUp = false;
      }
    },

    async verificarModoFollowUp() {
      try {
        const response = await api.get(
          `web-cliente/empresa/${this.dadosEmpresa.id}/follow-up/mode`
        );
        this.modoFollowUp = response.data.modo;
      } catch (error) {
        console.error("Erro ao verificar modo follow-up:", error);
        this.modoFollowUp = 0;
      }
    },

    // Só a empresa habilitada, e só onde a aprovação já aconteceu.
    // 9/10 = fluxo Clicksign (o caso da empresa 70, assinarClicksign "local");
    // 21/22 = mesmos estados no fluxo de assinatura presencial, incluídos para
    // a coluna não sumir se a empresa mudar de configuração.
    mostrarAprovador(item) {
      return (
        this.empresaExibeAprovador &&
        [9, 10, 21, 22].includes(Number(item.idStatus)) &&
        !!item.aprovadoPor
      );
    },

    showModalFollowUp(candidato) {
      // Definir dados do candidato
      this.candidato = {
        id: candidato.id,
        nome: candidato.nome,
        email: candidato.email,
        urlFotoPerfil: candidato.urlFotoPerfil,
        data_base: candidato.data_base,
        responsavelTipo: candidato.responsavelTipo,
        prazoPadrao: candidato.prazoPadrao,
        tipoCalculoPrazo: candidato.tipoCalculoPrazo,
        status: candidato.status,
        statusDescricao: candidato.statusDescricao,
        statusCor: candidato.statusCor,
      };

      // Chamar o método do componente
      this.$refs["modal-follow-up"].mostrarModal();
    },
  },

  computed: {
    empresaTemFollowUpStore() {
      return this.$store.state.empresaFollowUp;
    },

    rows() {
      return this.items.length;
    },

    // O backend só devolve `aprovadoPor` nas empresas habilitadas
    // (EMPRESAS_EXIBE_APROVADOR), então a regra mora num lugar só.
    empresaExibeAprovador() {
      return (this.itemsTodos || []).some((item) => "aprovadoPor" in item);
    },

    empresaExibeFiltroDocumentosBaixados() {
      return (
        this.dadosEmpresa &&
        [70, 500].includes(Number(this.dadosEmpresa.id)) &&
        this.abaAtiva === "Concluídos"
      );
    },

    dataHoraDocumentosBaixados() {
      if (!this.candidato.documentosBaixadosEm) return "";
      return dayjs(this.candidato.documentosBaixadosEm).format(
        "DD/MM/YYYY [às] HH:mm"
      );
    },

    // Aprovadores presentes na lista, para popular o filtro.
    opcoesAprovador() {
      const nomes = [
        ...new Set(
          this.items
            .filter((item) => this.mostrarAprovador(item))
            .map((item) => item.aprovadoPor)
        ),
      ].sort((a, b) => a.localeCompare(b));

      return [
        { value: null, text: "Todos os aprovadores" },
        ...nomes.map((nome) => ({ value: nome, text: nome })),
      ];
    },

    itemsFilter() {
      let valores = [];
      const searchNormalized = this.search
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      valores = this.items.filter((item) => {
        const nomeNormalized = (item.nome || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const emailNormalized = (item.email || "").toLowerCase();
        const celularNormalized = (item.celular || "").toLowerCase();
        const cpfNormalized = (item.cpf || "").toLowerCase();
        const funcaoNormalized = (item.nomeFuncao || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const statusNormalized = (item.status || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const ufNormalized = (item.uf || "").toLowerCase();
        const cidadeNormalized = (item.cidade || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const regiaoNormalized = (item.nomeRegiao || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const clienteNormalized = (item.cliente || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        const aprovadoPorNormalized = (item.aprovadoPor || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        return (
          nomeNormalized.indexOf(searchNormalized) > -1 ||
          emailNormalized.indexOf(searchNormalized) > -1 ||
          celularNormalized.indexOf(searchNormalized) > -1 ||
          cpfNormalized.indexOf(searchNormalized) > -1 ||
          funcaoNormalized.indexOf(searchNormalized) > -1 ||
          statusNormalized.indexOf(searchNormalized) > -1 ||
          ufNormalized.indexOf(searchNormalized) > -1 ||
          cidadeNormalized.indexOf(searchNormalized) > -1 ||
          regiaoNormalized.indexOf(searchNormalized) > -1 ||
          clienteNormalized.indexOf(searchNormalized) > -1 ||
          aprovadoPorNormalized.indexOf(searchNormalized) > -1
        );
      });

      // Filtro dedicado por aprovador (só na empresa habilitada)
      if (this.empresaExibeAprovador && this.filtroAprovador) {
        valores = valores.filter(
          (item) => item.aprovadoPor === this.filtroAprovador
        );
      }

      // Filtro por documentos baixados (só nas empresas 70 e 500)
      if (
        this.empresaExibeFiltroDocumentosBaixados &&
        this.filtroDocumentosBaixados !== null
      ) {
        valores = valores.filter(
          (item) => !!item.documentosBaixados === this.filtroDocumentosBaixados
        );
      }

      return valores;
    },

    fieldsCondicionais() {
      if (this.abaAtiva === "Pendências") {
        return this.fieldsPendencias;
      } else {
        return this.fields;
      }
    },

    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--height": this.height + "px",
        "--font-color": this.fontColor,
      };
    },
    cssTitulo() {
      return {
        "--color": this.color,
        "--height": this.height + "px",
      };
    },

    dataMinAprovacaoContrato() {
      // Valida se a data de emissão existe e é válida
      if (this.candidato.dataEmissaoContrato) {
        const dataEmissao = new Date(this.candidato.dataEmissaoContrato);
        if (!isNaN(dataEmissao.getTime())) {
          // Data válida, retorna no formato ISO
          return dataEmissao.toISOString().split("T")[0];
        } else {
          console.warn(
            "⚠️ Data de emissão inválida:",
            this.candidato.dataEmissaoContrato
          );
        }
      }
      // Fallback seguro: 30 dias atrás
      const fallbackDate = new Date();
      fallbackDate.setDate(fallbackDate.getDate() - 30);
      return fallbackDate.toISOString().split("T")[0];
    },
  },
};
</script>

<style lang="scss" scoped>
#gerenciarCandidatos {
  background-color: #ebeff3;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgb(163 194 208 / 1%);
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: unset !important;
  border-top: rgb(163 194 208 / 1%);
}
#Candidatos {
  position: inherit;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: 5rem;
  padding: 18px;
  margin-top: -65px;
  margin-left: 5%;
  width: 90%;
}

#Filtros {
  position: inherit;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: 5rem;
  padding: 18px;
  margin-top: 25px;
  margin-left: 5%;
  width: 90%;
}

.titulo {
  position: inherit;
  display: block;
  margin-top: 20px;
  margin-left: 5%;
}

.buscaMaisRefresh {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 480px) {
  #Candidatos {
    position: inherit;
    display: block;
    padding: 0;
    margin-bottom: -0;
    background-color: #f9f9f900;
    border: 1px solid rgba(0, 0, 0, 0);
    border: solid 1px rgba(204, 204, 204, 0);
  }

  #Filtros {
    position: inherit;
    display: block;
    padding: 0;
    margin-bottom: -0;
    background-color: #f9f9f900;
    border: 1px solid rgba(0, 0, 0, 0);
    border: solid 1px rgba(204, 204, 204, 0);
  }
}

@media screen and (max-width: 768px) {
  #Candidatos {
    width: 98%;
    position: inherit;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    padding: 18px;
    margin-top: 10px;
    margin-left: 7px;
  }

  #Filtros {
    width: 98%;
    position: inherit;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    padding: 18px;
    margin-top: 25px;
    margin-left: 7px;
  }
}

.contorno {
  padding: 10px;
  margin-top: 45px;
  margin-right: 10px;
  margin-left: 10px;
  border: solid 1px #cccc;
  border-radius: 5px;
  background-color: #fff;
}

@media (max-width: 480px) {
  .contorno {
    border: solid rgba(204, 204, 204, 0);
    padding: 0;
    margin-top: 25px;
    margin-right: 0;
    margin-left: 0;
  }
}

.display-4 {
  float: left;
  padding: 10px;
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

/* Tooltip largo para justificativas */
:deep(.tooltip-justificativa-largo .tooltip-inner) {
  max-width: 600px !important;
  width: max-content !important;
  white-space: pre-line !important;
  text-align: left !important;
}

:deep(.tooltip-justificativa-largo) {
  max-width: 600px !important;
}

/* Modal histórico grande */
:deep(.modal-historico-large .modal-dialog) {
  max-width: 90vw !important;
  width: 90vw;
}

:deep(.modal-historico-large .table-responsive) {
  overflow-x: visible;
}

:deep(.modal-historico-large table) {
  table-layout: auto;
  width: 100%;
}

:deep(.modal-historico-large td) {
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

.titulo {
  font-size: 2rem !important;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  margin-top: 5px;
}

@media (min-width: 576px) {
}
.jumbotron {
  padding: 2rem 2rem;
}

@media (min-width: 480px) {
}
.jumbotron {
  padding: 1rem 1rem;
}

.pagination {
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
  justify-items: center;
  justify-content: center;
  margin-top: 2rem;
}

p {
  padding-left: 1rem;
}

.cor_danger {
  font-weight: 400;
  text-align: center;
  background: #8e1c42 !important;
  font-size: 1rem;
  line-height: 1.5;
}

.active {
  font-weight: 600;
  color: #ff0202 !important;
  background: none;
  border: none;
  border-bottom-color: currentcolor;
  border-bottom-style: none;
  border-bottom-width: medium;
  border-bottom: 3px solid #ff0202;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  background-color: #8e1c42 !important;
}

.box1 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.card {
  margin-top: -25px;
}

.card {
  display: flex;
  border-radius: 6px;
  padding: 1%;
  margin-bottom: 1rem;
  background-color: var(--bg-color);
}

@media (max-width: 480px) {
  .card {
    padding: 2%;
  }
}

.card .card-title {
  margin-top: 0;
  margin-bottom: 3px;
  color: var(--color);
  // color: #fff;
}
.lero-btn {
  margin-left: 89%;
  justify-content: center;
  margin-top: -29px;
}

@media (max-width: 480px) {
  .lero-btn {
    margin-left: 62%;
  }
}

.box {
  width: 800px;
  padding: 40px;
  margin: 50px auto;
  box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.1);
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 500%;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  font-size: 12px;
}

.nav-item > .nav-link {
  color: #fff;
}

.a {
  color: #000000 !important;
  text-decoration: none;
  background-color: transparent;
}

.bar[data-v-1057c27b] {
  width: 120px;
  padding: 0px 13px 15px 0px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  margin-top: 1px;
  position: relative;
  height: 24px;
  border-radius: 3px;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2), 0 -1px 1px #fff, 0 1px 0 #fff;
}

// .bar[data-v-1057c27b] {
//     width: 120px;
//     margin-top: -15px;
//     position: absolute;
//     height: 22px;
//     border-radius: 3px;
//     overflow: hidden;
//     border-bottom: 1px solid #ddd;
//     box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2), 0 -1px 1px #fff, 0 1px 0 #fff;
// }

.porcento {
  // float: right;
  font-weight: 600;
  line-height: 22px;
}

.progress {
  display: flex;
  // height: 30px;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #0da164;
  border-radius: 0.25rem;

  background-size: 30px 30px;
  background-image: linear-gradient(
    135deg,
    rgba($color: #fff, $alpha: 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba($color: #fff, $alpha: 0.15) 50%,
    rgba($color: #fff, $alpha: 0.15) 75%,
    transparent 75%,
    transparent
  );
}

.progress {
  float: left;
  padding: 15px;
}

.progress2 {
  display: flex;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #f50808;
  border-radius: 0.25rem;
  background-size: 30px 30px;
  background-image: linear-gradient(
    135deg,
    rgba($color: #fff, $alpha: 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba($color: #fff, $alpha: 0.15) 50%,
    rgba($color: #fff, $alpha: 0.15) 75%,
    transparent 75%,
    transparent
  );
}

.progress2 {
  float: left;
  padding: 15px;
}

.progress3 {
  display: flex;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #ffc107;
  border-radius: 0.25rem;
  background-size: 30px 30px;
  background-image: linear-gradient(
    135deg,
    rgba($color: #fff, $alpha: 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba($color: #fff, $alpha: 0.15) 50%,
    rgba($color: #fff, $alpha: 0.15) 75%,
    transparent 75%,
    transparent
  );
}

.progress3 {
  float: left;
  padding: 15px;
}

.color1 {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #31d0ec;
  border-radius: 0.25rem;
}

.disabilitar {
  display: block;
}

@media (max-width: 480px) {
  .card .card-title[data-v-52e8430a] {
    margin-top: 0;
    margin-bottom: 3px;
    color: #fff;
    justify-content: center;
    justify-items: center;
    align-items: center;
    display: flex;
  }
}

.altura {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  height: min-content;
  min-height: 448px !important;
}

li {
  list-style: none;
}

.btn {
  padding: 0;
  font-size: 1rem;
  line-height: 2;
}

.btn-copiar-link {
  padding: 6px;
}

.card[data-v-1057c27b] {
  display: flex;
  border-radius: 6px;
  padding: 1%;
  margin-bottom: 1rem;
  background-color: var(--bg-color);
  margin-top: 5px;
  border: 0px solid rgba(0, 0, 0, 0.125);
}

p[data-v-1057c27b] {
  padding-left: 0;
}
.modal-title {
  font-size: 28px !important;
}

.tituloHistorico h5 {
  font-size: 1.5rem;
  font-weight: 600;
  padding-left: 13px;
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa00;
  border-color: #f8f9fa00;
}

.btn-light:hover {
  color: #212529;
  background-color: #e2e6ea00;
  border-color: #dae0e500;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff0;
  border: 1px solid #dee2e600;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.badge {
  padding: 5px 8px 7px;
}

.col-lg-12 {
  padding-left: 0;
  padding-right: 0;
}

.box-btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn-fechar {
  padding: 5px;
  width: 30%;
}

.icone {
  font-size: 25px;
}

.dropdown-acoes {
  border-radius: 70px;
  background-color: var(--bg-color);
}

.button-atualizar {
  background-color: var(--bg-color);
  border-color: var(--bg-color);
  color: var(--font-color);
}

.button-atualizar:hover {
  color: var(--font-color);
}

.button-atualizar:focus {
  background-color: var(--bg-color);
  border-color: var(--bg-color);
  color: var(--font-color);
}

.avatar-foto-perfil {
  margin-top: 15px;
}

// .info-celular {
//   font-size: 15px;
// }
/* Quem aprovou o cadastro (exibido abaixo do status).
   Sem rótulo e sem ícone de propósito: o badge de status é o elemento
   principal da célula, e o nome do candidato já ocupa a coluna ao lado -
   esta linha precisa ler como informação secundária. O `title` cobre quem
   ainda não associou o nome ao filtro de aprovador no topo da tela. */
.aprovador {
  margin-top: 4px;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
  line-height: 1.3;
  color: #6c757d;
}

/* Só aparece quando há carimbo de CHEQUE (~27% dos aprovados da empresa 70).
   Contorno em vez de fundo sólido para não virar um segundo badge
   competindo com o status. */
.aprovador-cheque {
  margin-left: 4px;
  padding: 0 5px;
  border: 1px solid #e0a800;
  border-radius: 10px;
  font-size: 0.68rem;
  font-weight: 500;
  color: #856404;
}
</style>
